import { getCustomTag, useTranslation } from '@msdk/common'
import { ButtonIcon, Menu, MenuItem, MoreVertIcon } from '@msdk/ui'
import React, { MouseEvent, useState } from 'react'

interface Props {
  entityName: string
}

export function More(_props: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [open, setOpen] = useState<boolean>(false)
  const logEnabled = false
  const t = useTranslation()

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget)
    setOpen(true)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setOpen(false)
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleLogClick = () => {}

  return (
    <>
      {logEnabled && (
        <>
          <ButtonIcon onClick={handleClick}>
            <MoreVertIcon />
          </ButtonIcon>
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            <MenuItem onClick={handleLogClick} data-test-id={getCustomTag(['view', 'more', 'button'])}>
              {t('CMPSR_LOG', 'Log')}
            </MenuItem>
          </Menu>
        </>
      )}
    </>
  )
}
